var map = {
	"./Bitfinex.png": 1041,
	"./Coolbitx.png": 1042,
	"./Cryptolocally.png": 1043,
	"./Gemini.png": 1044,
	"./LocalCryptos.png": 1045,
	"./Paysend.png": 1046,
	"./PrimeTrust.png": 1047,
	"./Revolut.png": 1048,
	"./Swissquote.png": 1049,
	"./Trikato.png": 1050,
	"./binance.png": 1051,
	"./bitstamp.png": 1052,
	"./coinbase.png": 1053,
	"./coincola.png": 1054,
	"./comistar.jpeg": 1055,
	"./comistar.png": 1056,
	"./gateio.png": 1057,
	"./huobi.png": 1058,
	"./independentreserve.png": 1059,
	"./kraken.png": 1060,
	"./okex.png": 1061,
	"./payoneer.png": 1062,
	"./paysera.png": 1063,
	"./poloniex.png": 1064,
	"./transferwise.png": 1065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1040;